<template>
  <div class="add-form">
    <div class="back-title">
      <span @click="onCancel"><i class="el-icon-back" /> 返回上一级</span>
    </div>

    <div class="form-title">
      <span v-if="pid">{{ form.name }} 的权限组信息</span>
      <span v-else>新增权限组</span>
    </div>

    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="120px"
             label-position="left">
      <el-form-item label="组名"
                    prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="权限类型"
                    prop="authorization">
        <el-input v-model="form.authorization" />
      </el-form-item>
      <el-form-item label="页面路由">
        <el-input v-model="form.routers"
                  type="textarea"
                  rows="3"
                  placeholder="可访问页面，每个页面换行隔开，*通配符匹配任意字符，例：/admin/*" />
      </el-form-item>
      <el-form-item label="备注信息">
        <el-input v-model="form.remarks"
                  type="textarea"
                  rows="3"
                  placeholder="请填入备注信息" />
      </el-form-item>
      <el-form-item label="组内用户">
        <el-cascader v-model="form.users"
                     :options="options"
                     :props="props1"
                     clearable
                     collapse-tags
                     filterable></el-cascader>
        <!-- <el-select v-model="form.users"
                   multiple
                   filterable
                   style="width:400px;"
                   placeholder="请选择或搜索用户名">
          <el-option v-for="u in allUsers"
                     :key="u.id"
                     :label="u.name"
                     :value="u.id" />
        </el-select> -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSubmit">
          提交
        </el-button>
        <el-button @click="onCancel">
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  queryUserGroup, queryUserInfo, addAuthGroup, updateAuthGroup, queryAuthGroupInfo, queryUser, queryUserGroupInfo,
} from '@/api/admin';
import { mapActions } from 'vuex';

export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    pid: {
      default: null,
    },
  },
  data() {
    return {
      options: [],
      props1: { multiple: true },
      form: {
        users: [],
      },
      query: {
        page: 1,
        per_page: 10000,
      },
      allUsers: [],
      rules: {
        authorization: [{ required: true, message: '请输入权限类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入组名', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getGroups();
    this.getUsers();
    if (this.pid) {
      this.fetchData();
    }
  },
  methods: {
    getGroups() {
      queryUserGroup({ page: 1, per_page: 10000 }).then((res) => {
        this.options = [];
        // eslint-disable-next-line
        res.data.groups.map((item) => {
          // eslint-disable-next-line
          queryUserGroupInfo({ id: item.id }).then((res) => {
            const children = res.data.users.reduce((a, b) => a.concat({ value: b.id, label: b.name }), []);
            this.options.push({ value: item.id, label: item.name, children });
          });
        });
      });
    },
    ...mapActions(['getAllUsers']),
    fetchData() {
      const users = [];
      const params = { id: this.pid };
      queryAuthGroupInfo(params).then((res) => {
        if (res.data) {
          const result = res.data;
          result.users = result.users.map(item => item.id, 0);
          // eslint-disable-next-line
          result.users.map((item) => {
            // eslint-disable-next-line
            queryUserInfo({ id: item }).then((res) => {
              users.push([res.data.user_groups.id, item]);
            }).then(() => {
              if (users.length === result.users.length) {
                result.users = users;
                this.form = result;
              }
            });
          });
        }
      });
    },
    getUsers() {
      const params = Object.assign({}, this.query);
      params.query_filters = {};
      this.getAllUsers().then((users) => {
        this.allUsers = users;
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form);
          let users = [];
          users = this.form.users.reduce((a, b) => a.concat(b[1]), []);
          params.users = users;
          if (this.pid) {
            updateAuthGroup(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          } else {
            addAuthGroup(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    onCancel() {
      this.$emit('setRPQ', { r: 'list', p: undefined });
    },
  },
};
</script>
